import { Box, Grid } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import { MainContainerForm } from "../../../styles/Main.styles";
import { useAddStockHistory } from "../api/product/stock/resolver";

interface StockAdjustment {
  productId?: string;
}

export type Form_Create_Stock = {
  product_id: string;
  quantity: string;
  description: string;
};

export default function StockAdjustment({ productId }: StockAdjustment) {
  const { control, handleSubmit } = useForm<Form_Create_Stock>({
    defaultValues: {
      description: "",
      quantity: "",
      product_id: productId,
    },
  });
  const { mutate: mutateAddStockHistory, isLoading: loadingAddHistoryStock } =
    useAddStockHistory();

  const handleFormSubmit: SubmitHandler<Form_Create_Stock> = (data) => {
    mutateAddStockHistory({ ...data });
  };

  return (
    <MainContainerForm>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="quantity"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Jumlah"
                  value={field.value}
                  error={fieldState.error?.message}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="description"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.TextArea
                  row={10}
                  label="Catatan"
                  value={field.value}
                  error={fieldState.error?.message}
                  onChange={(e) => field.onChange(e)}
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            mt={1}
            display={"flex"}
            justifyContent={"flex-end"}
          >
            <LoadingButton
              type="submit"
              isLoading={loadingAddHistoryStock}
              text="Update"
            />
          </Grid>
        </Grid>
      </form>
    </MainContainerForm>
  );
}
